var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.116 17.5846C19.5552 18.0238 19.5552 18.7363 19.116 19.1755C18.6768 19.6147 17.9643 19.6147 17.5251 19.1755L11.9863 13.5955L6.40819 19.1737C5.96902 19.6128 5.25647 19.6128 4.81725 19.1737C4.37804 18.7345 4.37808 18.0219 4.81725 17.5827L10.3973 12.0065L4.81571 6.38615C4.37654 5.94698 4.37654 5.23444 4.81571 4.79522C5.25488 4.356 5.96743 4.35604 6.40664 4.79522L11.9863 10.4174L17.5644 4.83928C18.0036 4.40011 18.7162 4.40011 19.1554 4.83928C19.5946 5.27845 19.5946 5.991 19.1554 6.43022L13.5754 12.0065L19.116 17.5846Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.1c07e724141498539eb923275aec86d1.svg";
export { ForwardRef as ReactComponent };